import React, { useState, useRef, useEffect } from "react";
import "./WebHeader.css";

interface WebHeaderProps {
  userName: string;
  userEmail: string;
  darkMode: boolean;
  onToggleDarkMode: () => void;
  onLogout: () => void;
}

const WebHeader: React.FC<WebHeaderProps> = ({ userName, userEmail, darkMode, onToggleDarkMode, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const initials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2) || "?";

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="web-header">
      <a href={window.location.hostname.includes("dev") ? "https://dev.ganttprojectplanner.com" : "https://ganttprojectplanner.com"} className="web-header-logo">Gantt Project Planner</a>
      <div className="web-header-user" ref={menuRef}>
        <button className="web-header-user-btn" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="web-header-avatar">{initials}</div>
          <span className="web-header-name">{userName}</span>
        </button>
        {menuOpen && (
          <div className="web-header-menu">
            <div className="web-header-menu-email">{userEmail}</div>
            <div className="web-header-menu-divider" />
            <button className="web-header-menu-item" onClick={() => { onToggleDarkMode(); setMenuOpen(false); }}>
              {darkMode ? "Light Mode" : "Dark Mode"}
            </button>
            <div className="web-header-menu-divider" />
            <button className="web-header-menu-item" onClick={onLogout}>
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WebHeader;
